<aside class="sidebar">
  <div class="section-label">Schema Onboarding</div>

  <div
    *ngFor="let item of navItems"
    class="nav-item"
    [class.active]="activeModule === item.id"
    (click)="switch(item.id)"
  >
    <div class="active-bar" *ngIf="activeModule === item.id"></div>

    <span *ngIf="item.id === 'portfolio'"           class="material-symbols-outlined">account_tree</span>
    <span *ngIf="item.id === 'initiative'"          class="material-symbols-outlined">rocket_launch</span>
    <span *ngIf="item.id === 'risk'"                class="material-symbols-outlined">shield</span>
    <span *ngIf="item.id === 'okr'"                 class="material-symbols-outlined">my_location</span>
    <span *ngIf="item.id === 'delivery_obligations'"class="material-symbols-outlined">handshake</span>
    <span *ngIf="item.id === 'metrics'"             class="material-symbols-outlined">monitoring</span>
    <span *ngIf="item.id === 'vendor_master'"       class="material-symbols-outlined">store</span>
    <span *ngIf="item.id === 'workforce_catalog'"   class="material-symbols-outlined">badge</span>
    <span *ngIf="item.id === 'people_competency_map'"class="material-symbols-outlined">psychology</span>
    <span *ngIf="item.id === 'profit_cost_centres'" class="material-symbols-outlined">account_balance</span>
    <span *ngIf="item.id === 'turnkey_plans'"       class="material-symbols-outlined">checklist</span>
    <span *ngIf="item.id === 'module_owners'"        class="material-symbols-outlined">pin_drop</span>
    <span *ngIf="item.id === 'catalog_owners'"       class="material-symbols-outlined">assignment_ind</span>

    {{ item.label }}
  </div>

  <!-- Tech Map group -->
  <div class="nav-item nav-group-header" [class.active]="isTechMapActive" (click)="toggleTechMap()">
    <div class="active-bar" *ngIf="isTechMapActive"></div>
    <span class="material-symbols-outlined">device_hub</span>
    Tech Map
    <svg class="chevron" [class.open]="techMapOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  </div>

  <div class="nav-sub-items" [class.visible]="techMapOpen">
    <div
      *ngFor="let sub of techMapItems"
      class="nav-item nav-sub-item"
      [class.active]="activeModule === sub.id"
      (click)="switch(sub.id)"
    >
      <div class="active-bar" *ngIf="activeModule === sub.id"></div>
      <span *ngIf="sub.id === 'tech_map_applications'"   class="material-symbols-outlined">apps</span>
      <span *ngIf="sub.id === 'tech_map_infrastructures'"class="material-symbols-outlined">dns</span>
      <span *ngIf="sub.id === 'tech_map_services'"       class="material-symbols-outlined">hub</span>
      {{ sub.label }}
    </div>
  </div>

  <!-- TBM Taxonomy group -->
  <div class="nav-item nav-group-header" [class.active]="isTbmActive" (click)="toggleTbm()">
    <div class="active-bar" *ngIf="isTbmActive"></div>
    <span class="material-symbols-outlined">analytics</span>
    TBM Taxonomy
    <svg class="chevron" [class.open]="tbmOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  </div>

  <div class="nav-sub-items" [class.visible]="tbmOpen">
    <div
      *ngFor="let sub of tbmItems"
      class="nav-item nav-sub-item"
      [class.active]="activeModule === sub.id"
      (click)="switch(sub.id)"
    >
      <div class="active-bar" *ngIf="activeModule === sub.id"></div>
      <span *ngIf="sub.id === 'tbm_cost_pool'" class="material-symbols-outlined">savings</span>
      <span *ngIf="sub.id === 'tbm_it_tower'"  class="material-symbols-outlined">layers</span>
      <span *ngIf="sub.id === 'tbm_service'"   class="material-symbols-outlined">build</span>
      <span *ngIf="sub.id === 'tbm_solution'"  class="material-symbols-outlined">extension</span>
      {{ sub.label }}
    </div>
  </div>

  <!-- Expert Led -->
  <div
    class="nav-item"
    [class.active]="activeModule === 'expert_led'"
    (click)="switch('expert_led')"
  >
    <div class="active-bar" *ngIf="activeModule === 'expert_led'"></div>
    <span class="material-symbols-outlined">support_agent</span>
    Expert Led
  </div>

</aside>
